<div><mat-form-field appearance="outline" class="search-filter">
    <mat-label>Sök</mat-label>
    <input matInput [(ngModel)]="searchTerm" (keyup)="filterSelectableValuesByQuery()" placeholder="Sök"
      class="search-input">
    <mat-icon matSuffix>search</mat-icon>
  </mat-form-field>
</div>
<app-filter-button label="Ort" [allValues]="this.allCities" [(selectedValues)]="this.filterValues.cities"
  (selectedValuesChange)="applyFilter()"></app-filter-button>

<app-filter-button label="Status entreprenörslista" [allValues]="this.allContractorListStatuses"
  [(selectedValues)]="this.filterValues.statuses" (selectedValuesChange)="applyFilter()"></app-filter-button>

<app-filter-input-chips [(selectedValues)]="this.filterValues" (selectedValuesChange)="applyFilter()"
  [tableId]="'contractor-table'"></app-filter-input-chips>